import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return ({
		iconContainer: {
			display: "flex",
			flex: "0 0 50px",
			justifyContent: "center",
		},
		actionContainer: {
			display: "flex",
			flex: "0 0 50px",
			justifyContent: "center",
		}
	} satisfies Record<string, CSSObject>)
};
